import request from "@utils/request";

/**
 * 首页
 * @returns {*}
 */
export function getHomeData() {
    return request.get("index", {}, { login: false });
}

/**
 * 文章 轮播列表
 * @returns {*}
 */
export function getArticleBanner() {
    return request.get("/article/banner/list", {}, { login: false });
}

/**
 * 文章分类列表
 * @returns {*}
 */
export function getArticleCategory() {
    return request.get("/article/category/list", {}, { login: false });
}

/**
 * 文章 热门列表
 * @returns {*}
 */
export function getArticleHotList() {
    return request.get("/article/hot/list", {}, { login: false });
}

/**
 * 文章列表
 * @returns {*}
 */
export function getArticleList(q, cid) {
    return request.get("/article/list/" + cid, q, { login: false });
}

/**
 * 分享
 * @returns {*}
 */
export function getShare() {
    return request.get("/share", {}, { login: false });
}

/**
 * 文章详情
 * @returns {*}
 */
export function getArticleDetails(id, token) {
    return request.get("/article/details/" + id, { token }, { login: false });
}

/**
 * 获取微信sdk配置
 * @returns {*}
 */
export function getWechatConfig() {
    return request.get(
        "/wechat/config", { url: document.location.href }, { login: false }
    );
}

/**
 * 获取微信sdk配置
 * @returns {*}
 */
export function wechatAuth(code, spread, login_type) {
    return request.get(
        "/wechat/auth", { code, spread, login_type }, { login: false }
    );
}
/**
 * 获取快递公司
 * @returns {*}
 */
export function getLogistics() {
    return request.get("/logistics", {}, { login: false });
}

/**
 * 获取登陆logo
 * @returns {*}
 */
export function getLogo(type) {
    return request.get("/wechat/get_logo", { type: type }, { login: false });
}

/**
 * 获取图片base64
 * @retins {*}
 * */
export function imageBase64(image, code) {
    return request.post(
        "/image_base64", { image: image, code: code }, { login: false }
    );
}

/**
 * 获取关注海报
 * @returns {*}
 */
export function follow() {
    return request.get("/wechat/follow", {}, { login: false });
}

/**
 * 获取城市列表
 * @returns {*}
 */
export function getCity() {
    return request.get("/city_list", {}, { login: false });
}


/**
 * 获取分类列表
 */
export function getFulianCate(pid) {
    return request.get("fulian/category/list/" + pid, {}, { login: false });
}

/**
 * 获取新闻列表
 */
export function getCate(pid) {
    return request.get("article/category/" + pid, {}, { login: false });
}

/**
 * 获取底部导航
 */
export function getNavCate() {
    return request.get("fulian/category/nav", {}, { login: false });
}

/**
 * 发布文章评论
 */
export function sendComment(data) {
    return request.post("fulian/article/comment", data, { login: false });
}

/**
 * 评论列表
 */
export function commentList(data) {
    return request.get("fulian/comment/list", data, { login: false });
}

/**
 * 点赞文章
 */
export function likeArticle(data) {
    return request.post("fulian/article/like", data, { login: false });
}

/**
 * 分享文章
 */
export function shareArticle(data) {
    return request.post("fulian/article/share", data, { login: false });
}


/**
 *(JY)
 * 首页推荐活动
 * @returns {*}
 */
export function getIsRecommend(q) {
    return request.get("fulian/article/is_recommend", q, { login: false });
}

/**
 *(JY)
 * 关爱帮扶-轮播图
 * @returns {*}
 */
export function getHelpContent() {
    return request.get("fulian/help/getHelpContent", {}, { login: false });
}

/**
 *(JY)
 * 关爱帮扶-报名
 * @param {Object} data
 */
export function AddDevotion(data) {
    return request.post("fulian/help/AddDevotion", data, { login: false });
}

/**
 *jy
 * 关爱帮扶-困境儿童列表
 * @returns {*}
 */
export function getDifficulty() {
    return request.get("fulian/help/getDifficulty", {}, { login: false });
}


/**
 * jy
 * 困境儿童详情
 * @param {Object} id
 */
export function getDetail(id) {
    return request.get("fulian/help/getDifficultyDetail/" + id, {}, { login: false });
}

/**
 * JY
 * 困境儿童表单提交
 * @param {Object} id
 * @param {Object} data
 */
export function AddDifficultyHelpInfo(id,data) {
    return request.get("fulian/help/AddDifficultyHelpInfo/" + id, data, { login: false });
}

/**
 * jy
 * 微心愿列表
 */
export function getWish(data) {
    return request.get("fulian/help/getWish", data, { login: false });
}


/**
 * jy
 * 微心愿详情
 * @param {Object} id
 */
export function getWishDetail(id) {
    return request.get("fulian/help/getWishDetail/" + id, {}, { login: false });
}

/**
 * JY
 * 微心愿表单提交
 * @param {Object} id
 * @param {Object} data
 */
export function AddWishInfo(id,data) {
    return request.get("fulian/help/AddWishInfo/" + id, data, { login: false });
}

/**
 * jy
 * 我的认领记录
 */
export function getMyWish() {
    return request.get("fulian/help/getMyWish", {}, { login: false });
}

/**
 * 获取社会服务分类
 */
export function getSocietyCategory() {
    return request.get("fulian/social/getSocietyCategory", {}, { login: false });
}


/**
 * jy
 * 服务子分类列表
 * @param {Object} id
 */
export function getPid(id) {
    return request.get("fulian/social/getPid/"+id, {}, { login: false });
}


/**
 * jy
 * 社会服务提交表单
 * @param {Object} id
 * @param {Object} data
 */
export function AddSocietyInfo(id,data) {
    return request.get("fulian/social/AddSocietyInfo/" + id, data, { login: false });
}


/**
 * jy
 * 获取主席审核列表
 */
export function getContents(data) {
    return request.get("fulian/contents", data, { login: false });
}


/**
 * jy
 * 主席审核
 */
export function Examine(data) {
    return request.post("fulian/examine", data, { login: false });
}